import React from 'react';
import {Grid, Typography} from "@mui/material";
import meet_logo from "../../assets/images/kozel_meet/meet_logo.png";
import useCodeAccessLpStyles from "../../styles/kozelMeetBoardGameAccess/code_access_lp";
import clsx from "clsx";
import copite from '../../assets/images/kozel_meet/board_game/copite.png';
import games from '../../assets/images/kozel_meet/board_game/jocuri.jpg';
import {useAppSelector} from "../../stores/store";
import {isNull} from "lodash";


const CodeAccessLp: React.FC = () => {
    const styles = useCodeAccessLpStyles();
    const {currentCode, nextCode} = useAppSelector(state => state.kozelMeetBoardGame);

    const showCodeMessage = () => {
        if (currentCode === nextCode) {
            return currentCode;
        }

        if(isNull(nextCode)) {
            return currentCode;
        }

        return `${currentCode} sau ${nextCode}`
    }

    return (
        <Grid container className={styles.container}>
            {/* <Grid item xs={12} className={styles.boxBorderWithCenterTitle}>
                <Typography className={styles.centerTopTitle}>INTRODUCING</Typography>
            </Grid> */}
            <Grid item xs={10} lg={6} display={"flex"} justifyContent={"center"}>
                <img src={meet_logo} alt={'MEEET KOZEL LOGO'} className={styles.logoKozelMeet}
                     style={{maxWidth: '425px', maxHeight: '240px'}}/>
            </Grid>
            <Grid item xs={10} lg={6} display={"flex"} justifyContent={"center"} mt={5}>
                <Typography className={styles.title}>GAMES, FIRENDS AND BEER,<br/>
                                    THURSDAYS ARE FOR CHEER</Typography>
            </Grid>
            <Grid item xs={12} lg={8} className={clsx(styles.item, styles.borderDotted)}>
                <Grid container className={styles.subContainer}>
                    <Grid item xs={12} className={clsx(styles.subItem, styles.boxTitle)}>
                        <Typography className={styles.title}>Congrats!</Typography>
                        <Typography className={styles.title}>Your picture has been uploaded.</Typography>
                    </Grid>
                    <Grid item xs={12} className={styles.subItem}>
                        <Typography className={styles.text}>The code to unlock the Games is</Typography>
                    </Grid>
                    <Grid item xs={12} className={styles.subItem}>
                        <Typography className={styles.codeText}>{showCodeMessage()}</Typography>
                    </Grid>
                    <Grid item xs={12} className={styles.subItem}>
                        <Typography className={styles.text}>Now, go to <u>Kozel Wall of Games</u> to access the games.
                            Please leave the games in good working condition so that other Kozel friends can enjoy them too!</Typography>
                    </Grid>
                    <Grid item xs={12} className={clsx(styles.subItem, styles.middleBorderDotted)}>
                        <Typography className={styles.subtitle}>Follow these simple steps:</Typography>
                    </Grid>
                    <Grid item xs={12} className={clsx(styles.subItem, styles.boxSteps)}>
                        <Typography className={styles.stepNumber}>1</Typography>
                        <Typography className={styles.stepText}>Go to Kozel Wall of Games and insert the above code to access your desired boardgame.</Typography>
                    </Grid>
                    <Grid item xs={12} className={clsx(styles.subItem, styles.boxSteps)}>                        
                        <Typography className={clsx(styles.stepText, styles.stepTextFirst)}>Choose your desired game, close the door and change the code with a random one so that other Kozel friends may enjoy the fun game experience.</Typography>                        
                        <Typography className={styles.stepNumber}>2</Typography>
                    </Grid>
                    <Grid item xs={12} className={clsx(styles.subItem, styles.boxSteps)}>
                        <Typography className={styles.stepNumber}>3</Typography>
                        <Typography className={styles.stepText}>After you had fun together, please leave the game where you found it (insert the above code to re-open the door) and finally change the code with a random one so all Kozel friends may enjoy the full experience.</Typography>
                    </Grid>
                    <Grid item xs={12} display={'flex'} justifyContent={'center'} alignItems={'center'}
                          alignContent={'center'} alignSelf={'center'}>
                        <img src={copite} alt={'steps kozel'} className={styles.img}
                             style={{maxWidth: '290px', maxHeight: "75px"}}/>
                    </Grid>
                    <Grid item xs={12} className={styles.subItem}>
                        <Typography className={styles.bigText}>Have FUN!</Typography>
                    </Grid>
                    <Grid item xs={12} className={styles.subItem}>
                        <img src={games} alt={'totem game'} className={styles.img}
                             style={{maxWidth: '790px', maxHeight: "440px"}}/>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default CodeAccessLp;
